import {
  initialFormAttributesState,
  FormAttributesState
} from '../states/form-attributes.state';
import {
  FormAttributesActions,
  EFormAttributesActions
} from '../actions/form-attributes.actions';

export function formAttributesReducers(
  state = initialFormAttributesState,
  action: FormAttributesActions
): FormAttributesState {
  switch (action.type) {
    case EFormAttributesActions.ListFormAttributes: {
      // Keep previous data visible until success (avoids blank screens on refresh).
      return state;
    }

    case EFormAttributesActions.ListFormAttributesSuccess: {
      return {
        ...state,
        formAttributes: action.payload.attributes,
        loadedFormId: action.payload.formId
      };
    }

    case EFormAttributesActions.ListFormAttributesFailure: {
      return state;
    }

    default:
      return state;
  }
}
